import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useParams, Link, useHistory } from "react-router-dom";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import {
  getByIdEventTask,
  getMyEventTask,
  updateRevertTask,
} from "app/_services/ehs/ehsEventScheduleServices";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { updateEventTask } from "app/_services/ehs/ehsEventScheduleServices";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";
import { TASK_STATUS } from "./CONSTANT";
import { userDropdownLabel } from "app/_helpers/helper";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import YesOrNo from "../YesOrNo.component";
import MeetingTimeline from "./Component/MeetingTimeline";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import ViewComments from "../IncidentManagement/ViewComments";
import { getLoggedInUserId } from "../IncidentManagement/Helper";
import MultipleFileUpload from "app/views/custom/components/FileUpload/MultipleFileUpload";
import CompletionProof from "../CapaManagement/CompletionProof";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import MultiSelectTwo from "app/Components/SearchableSelect/MultiSelectTwo";
import { UserService } from "app/_services/UserService/UserService";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";

function RevertTaskUpdate({ history }) {
  const [form, setForm] = useState([]);
  const [oldForm, setOldForm] = useState([]);
  const [errorForm, setErrorForm] = useState([]);
  const [users, setUsers] = useState([]);
  const { location } = useHistory();

  let { id, siteId } = useParams();
  useEffect(() => {
    getByIdEventTask(id).then((response) => {
      if (!response?.data) return;
      const ownerDataObj = response.data?.taskOwners.find(
        (d) => d.ownerId === location.state?.ownerId
      );
      const formObj = {
        ...response.data,
        ownerId: ownerDataObj?.ownerId,
        comment: ownerDataObj?.comment,
        ownerData: ownerDataObj,
        completionProofId: ownerDataObj?.completionProofId,
        completionProof: ownerDataObj?.completionProof,
      };
      setForm(formObj);
      setOldForm(formObj);
    });
  }, [id, location.state?.ownerId]);

  const onChange = ({ target: { name, value } }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onChangeDate = ({ name, value }) => {
    setForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      setUsers(response.data);
    });
  }, []);

  const onSubmit = async () => {
    // const errObj = Validation(form, [
    //     {
    //         field_name: "finialStatus",
    //         label: "Finial Status",
    //         type: "string",
    //         isRequired: true,
    //     },
    //     {
    //         field_name: "comment",
    //         label: "Describe Actions Taken or Resolution Provided",
    //         type: "string",
    //         isRequired: true,
    //     },
    // ]);

    // setErrorForm(errObj);

    // for (const key in errObj) if (errObj[key]) return;
    const objData = {
      // taskDescription: form?.taskDescription,
      taskDueDate: form?.taskDueDate,
      ownerId: form?.ownerId,
      oldOwnerId: oldForm?.ownerData?.ownerId,
    };

    const response = await updateRevertTask(id, objData);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response?.message);
    history.goBack();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          // {
          //   name: "My Approval Actions",
          //   path: "/health-safety-and-environment/OHSE Review Tasks/view-tasks",
          // },

          {
            name: "Edit",
          },
        ]}
      />
      <div className="card p-3 mt-4" style={{ height: "550px" }}>
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-0">Details</h3>
        </div>
        <div className="ehsFormWrapper">
          <Row>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Task ID</h5>
                <p>{oldForm?.taskId}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Task Owner</h5>
                <p>{userDropdownLabel(oldForm?.ownerData?.userData)}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">OHSE ID</h5>
                <Link
                  to={
                    "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/" +
                    oldForm?.ohseData?.id
                  }
                  target="_blank"
                  className=""
                >
                  <p>{oldForm?.ohseData?.scheduleId}</p>
                </Link>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Task Description</h5>
                <p>{oldForm?.taskDescription}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Task Due Date</h5>
                <p>{DDMMYYYYFormat(oldForm?.taskDueDate)}</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500">Created Date</h5>
                <p>{DDMMYYYYHHMMAFormat(oldForm?.createdAt)}</p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Return Message</h5>
                <p>{oldForm?.ownerData?.revertMessage}</p>
              </div>
            </Col>
          </Row>
          <Row>
            {/* <Col lg={4}>
                            <div className="form-group viewbox">
                                <h5 className="w-500 mb-1">Task Description</h5>
                                <input
                                    name="taskDescription"
                                    disabled={form?.isProgress ? true : false}
                                    className="form-control"
                                    onChange={onChange}
                                    value={
                                        form?.taskDescription
                                    }
                                />
                            </div>
                        </Col> */}
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Task Due Date</h5>
                <DatePicker
                  name="taskDueDate"
                  // timeFormat={"HH:mm:ss"}
                  value={form?.taskDueDate}
                  isValidDate={(m) => m.isAfter(new Date())}
                  readOnly={true}
                  onChange={(moment, name) => {
                    onChangeDate({
                      name,
                      value: moment.format("YYYY-MM-DD HH:mm:ss"),
                    });
                  }}
                />
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Task Owners</h5>
                <SimpleSelect
                  className="form-control"
                  name="ownerId"
                  value={form?.ownerId}
                  onChange={onChange}
                  id="id"
                  label="name"
                  options={users.map((d) => ({
                    ...d,
                    name: userDropdownLabel(d),
                    value: d.id,
                  }))}
                  //error={errorForm?.subAreaId}
                  init="Select"
                  // disabled
                ></SimpleSelect>
              </div>
            </Col>
          </Row>
          <div className="mb-2 text-center">
            <Button
              onClick={onSubmit}
              type="submit"
              variant="primary"
              className="m-1 text-capitalize"
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </div>
  );
}

export default RevertTaskUpdate;
